import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import { get } from "lodash";

import Grid from "@material-ui/core/Grid";

import { formatDate } from "../../../utils/date";

import { LANGUAGES } from "../../../constants/common";

import colors from "../../../assets/style/colors";

const styles = {
  container: {
    borderRadius: "10px",
    margin: "5px 0px",
    padding: "5px",
    maxWidth: "550px",
  },
  container_yes: {
    border: `1px solid ${colors.threatRed}`,
    backgroundColor: colors.threatRed10,
  },
  container_no: {
    border: `1px solid ${colors.cardGreen}`,
    backgroundColor: colors.cardGreen10,
  },
  container_skipped: {
    border: `1px solid ${colors.warningOrange}`,
    backgroundColor: colors.warningOrange10,
  },
  container_neutral: {
    border: `1px solid ${colors.black38}`,
    backgroundColor: colors.questionBg,
  },
  questionIndex: {
    width: "20px",
    display: "inline-block",
    textAlign: "right",
    marginRight: "5px",
  },
  answerBadge: {
    borderRadius: "2px",
    color: colors.white,
    padding: "3px 8px",
    marginRight: "10px",
    textAlign: "center",
  },
  answerBadge_yes: {
    backgroundColor: colors.threatRed,
  },
  answerBadge_no: {
    backgroundColor: colors.cardGreen,
  },
  answerBadge_skipped: {
    backgroundColor: colors.warningOrange,
  },
  answerBadge_neutral: {
    color: colors.black87,
    fontWeight: 500,
    backgroundColor: colors.greyBadgeBg,
  },
  showDetails: {
    justifyContent: "flex-end",
    display: "flex",
    alignItems: "center",
    color: colors.primary,
    "& :hover": {
      textDecoration: "underline",
    },
    "& span": {
      cursor: "pointer",
    },
  },
  leftPaddedItem: {
    paddingLeft: "25px",
    margin: "3px 0px",
  },
};

const ProfileSurveyQuestion = (props) => {
  const { classes, question, index, language, audio, surveyType } = props;
  const [showDetails, setShowDetails] = React.useState(false);
  const attr151 = JSON.parse(get(props.attr151, ["value"]));
  const questionDetails = get(attr151, ["questions", "answers", index]);

  const status =
    surveyType !== 81
      ? "neutral"
      : question.data_type === "boolean" && question.value === true
      ? "yes"
      : question.data_type === "boolean" && question.value === false
      ? "no"
      : "skipped";

  return (
    <Grid
      container
      direction="column"
      className={`${classes.container} ${classes[`container_${status}`]}`}
    >
      <Grid item>
        <Grid container wrap="nowrap">
          <Grid item className={`${classes.questionIndex} text-87 bold-500`}>
            {index + 1}.
          </Grid>
          <Grid item xs className="text-87 bold-500">
            {get(question, [`name_${language}`])}
          </Grid>
        </Grid>
      </Grid>
      <Grid item className={classes.leftPaddedItem}>
        <Grid container wrap="nowrap">
          <Grid
            item
            className={`${classes.answerBadge} ${
              classes[`answerBadge_${status}`]
            }`}
            style={{
              width: ![true, false].includes(question.value) ? "70px" : "42px",
            }}
          >
            {status === "neutral"
              ? question.value === true
                ? I18n.get("profiles_yes").toUpperCase()
                : question.value === false
                ? I18n.get("profiles_no").toUpperCase()
                : I18n.get("profiles_skipped").toUpperCase()
              : I18n.get(`profiles_${status}`).toUpperCase()}
          </Grid>
          <Grid item className="flexCenter">
            {get(questionDetails, ["context", "attempts"]) &&
              `${get(questionDetails, ["context", "attempts"])} ${I18n.get(
                "profiles_attempts"
              )} - `}
            {get(attr151, ["name"]) && status !== "skipped"
              ? `${get(attr151, ["name"])}, `
              : " "}
            {get(questionDetails, ["date"])
              ? formatDate(new Date(get(questionDetails, ["date"])))
              : ""}
          </Grid>
          {get(questionDetails, ["context", "attempts"]) && (
            <Grid item xs className={classes.showDetails}>
              <span onClick={() => setShowDetails(!showDetails)}>
                {I18n.get("profiles_details")}
              </span>
            </Grid>
          )}
        </Grid>
      </Grid>
      {showDetails && (
        <>
          <Grid item className={classes.leftPaddedItem}>
            <span className="text-87 bold-500" style={{ marginRight: "5px" }}>
              {I18n.get("profiles_language")}:
            </span>
            <span className="text-54">
              {get(questionDetails, ["question", "lang"]) &&
                get(questionDetails, ["question", "lang"]).toUpperCase()}
            </span>
          </Grid>
          <Grid item className={classes.leftPaddedItem}>
            <Grid container wrap="nowrap" alignItems="center">
              <Grid
                item
                className="text-87 bold-500"
                style={{ marginRight: "15px" }}
              >
                {I18n.get("profiles_answerGiven")}:
              </Grid>
              {get(audio, [0, "url"]) && (
                <Grid item>
                  <audio
                    controls
                    src={get(audio, [0, "url"])}
                    style={{ height: "20px", width: "180px" }}
                  />
                </Grid>
              )}
            </Grid>
            {get(questionDetails, ["context", "attempt_list"]) &&
              get(questionDetails, ["context", "attempt_list"]).map(
                (attempt, index) => (
                  <Grid
                    container
                    wrap="nowrap"
                    key={index}
                    className="text-87"
                    style={{ margin: "3px 0px" }}
                    alignItems="center"
                  >
                    <Grid item style={{ marginRight: "10px" }}>
                      {`${I18n.get("profiles_attempt")} ${index + 1}:`}
                    </Grid>
                    <Grid item style={{ fontStyle: "italic" }}>
                      {`"${attempt}"`}
                    </Grid>
                  </Grid>
                )
              )}
          </Grid>
        </>
      )}
    </Grid>
  );
};

ProfileSurveyQuestion.propTypes = {
  question: PropTypes.object,
  index: PropTypes.number.isRequired,
  language: PropTypes.oneOf(LANGUAGES),
  attr151: PropTypes.object,
};

export default withStyles(styles)(ProfileSurveyQuestion);
